import { render } from "./NotificationsMenu.vue?vue&type=template&id=764476df&scoped=true"
import script from "./NotificationsMenu.vue?vue&type=script&lang=js"
export * from "./NotificationsMenu.vue?vue&type=script&lang=js"

import "./NotificationsMenu.vue?vue&type=style&index=0&id=764476df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764476df"]])

export default __exports__